<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Νέα Πληρωμή</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <!-- Existing fields -->
            <v-col cols="2">
              <v-text-field
                label="ID"
                v-model="paymentForm.Id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="Ημερομηνία"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paymentForm.Date"
                  @input="menu = false"
                  :max="
                    new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                      .toISOString()
                      .substr(0, 10)
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="Τελική Τιμή"
                type="number"
                v-model="paymentForm.TotalValue"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="8" sm="6">
              <v-select
                label="Τρόπος Πληρωμής*"
                v-model="paymentForm.PaymTerm"
                :items="paymItems"
                required
              ></v-select>
            </v-col>
            <v-col cols="4" sm="6">
              <v-select
                v-if="showBank"
                label="Τράπεζα*"
                v-model="bank"
                :items="bankAccs"
                required
              ></v-select>
            </v-col>

            <!-- New fields for Επιταγή -->
            <v-col cols="6" v-if="paymentForm.PaymTerm === 3">
              <v-text-field
                label="Αριθμός Επιταγής"
                v-model="chequeNumber"
                prepend-icon="mdi-checkbook"
              ></v-text-field>
            </v-col>
            <v-col cols="6" v-if="paymentForm.PaymTerm === 3">
              <v-menu
                v-model="chequeDueDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="chequeDueDateText"
                    label="Ημερομηνία Λήξης Επιταγής"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="chequeDueDate"
                  @input="chequeDueDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" v-if="paymentForm.PaymTerm === 3">
              <v-text-field
                label="Όνομα Υπογράφοντος"
                v-model="signeeName"
                prepend-icon="mdi-file-sign"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                label="Remarks"
                v-model="paymentForm.Remarks"
                :hint="remarksText"
                persistent-hint
              >
                <template v-if="showBank" v-slot:append>
                  <v-avatar tile size=46>
                    <img
                      :alt="bank"
                      :src="bankLogo"
                    />
                  </v-avatar>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>* Υποχρεωτικά πεδία</small>
      </v-card-text>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="resetPayment"
      >
        Εκκαθάριση
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="close"
      >
        Κλεισιμο
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        :disabled="saveDisable"
        @click="createPayment"
      >
        Αποθηκευση
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</template>

<script>
 import { clone as _clone } from 'lodash';
import ab from "../assets/ab.png"
import nbg from "../assets/nbg.png"
import pir from "../assets/pir.png"
import eb from "../assets/eb.png"

  export default {

   computed: {
      dateRangeText () {
        return new Date(this.paymentForm.Date).toISOString().substr(0,10);
      },

      /* remarksText () {
        if (([1,2]).includes(this.paymentForm.PaymTerm)) {
            return this.paymentForm.Remarks + " " + this.bank
        } else {
            return this.paymentForm.Remarks
        }
      },
      */
      chequeDueDateText() {
        return this.chequeDueDate ? new Date(this.chequeDueDate).toISOString().substr(0, 10) : '';
      },
      remarksText() {
        let remarks = this.paymentForm.Remarks || '';
        if (this.paymentForm.PaymTerm === 3) {
          remarks = `ΑΡ. ΕΠΙΤ.: ${this.chequeNumber || ''}, ΗΜ/ΝΙΑ: ${this.chequeDueDateText}, ΥΠΟΓΡ.: ${this.signeeName || ''} ` + remarks;
        }
        if ([1, 2, 3].includes(this.paymentForm.PaymTerm)) {
          remarks += " " + this.bank;
        }
        return remarks;
      },
      showBank () { return (([1, 2, 3]).includes(this.paymentForm.PaymTerm)) },
      bankLogo () {
        return this.bankLogos[this.bank]
      },
    },
    props: {
        dialog: {
        default: false
      },
        apipath: {
          required: true
      },
        cid: {
          required: true
      },
     
      paymentForm: {
        type: Object,
        default() {
          return {
            Id: 0,
            Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            Remarks: null,
            PaymTerm: 1,
            TotalValue: 0,
         }
        }
      }
    },
    data() {
      return {
        menu: false,
        saveDisable: false,
        bankAccs: [
          {text: "Εθνική", value: "@NBG"},
          {text: "Alpha Bank", value: "@AB"},
          {text: "Eurobank", value: "@EB"},
          {text: "Πειραιώς", value: "@PIR"},
        ], 
        bank: "",
        bankLogos: {
            "@PIR": pir,
            "@NBG": nbg,
            "@AB": ab,
            "@EB": eb,
        },
        paymItems: [
          {text: "Καρτέλα", value: -2},
          {text: "Μεταφορά Υπολοίπου", value: -1},
          {text: "Μετρητά", value: 0},
          {text: "Κατάθεση σε τράπεζα", value: 1},
          {text: "Πληρωμή με κάρτα", value: 2},
          {text: "Επιταγή", value: 3},
        ],
        newPaymentForm: {
          Id: null,
          Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          Remarks: null,
          PaymTerm: 1,
          TotalValue: 0,
       },
      chequeNumber: '',
      chequeDueDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      chequeDueDateMenu: false,
      signeeName: '',
     }
    },

    methods: {
        close() {
        this.$emit('update:dialog', false)
      },
      async createPayment() {
        let payment = this.paymentForm;
        /* if (this.showBank) {
            if (this.paymentForm.Remarks){ 
              this.paymentForm.Remarks += " " + this.bank
            } else {
              this.paymentForm.Remarks = this.bank
            }
          }
        */
        payment.Remarks = this.remarksText;
        var response = await this.$api.post(`${this.apipath}/${this.cid}`, payment);
        if (response.status == 201) {
          this.paymentForm.Id = response.data.Id;
          this.saveDisable = true;
          alert(`Καταχωρήθηκε απόδειξη αξίας ${this.paymentForm.TotalValue} € με αριθμό ${this.paymentForm.Id}.`);
        } else {
          alert(response.data);
        }
      },
      resetPayment() {
        this.paymentForm = _clone(this.newPaymentForm);
        this.saveDisable = false;
        this.chequeNumber = '';
        this.chequeDueDate = null;
        this.signeeName = '';
      },
    },
  }

</script>
